<!--
  第三方登录
  lovi 2020-06-03
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('securitySet.thirdPartyLogin')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper">
      <van-cell-group>
        <van-cell title="Facebook" is-link>
          <template slot="default">
            <span
              v-if="thirdStatus.facebook_bind_status"
              class="text-blue"
              @click="unbind(2)"
            >
              {{ $t("common.unbind") }}
            </span>
            <template v-else>
              <fb-signin-button
                :params="fbSignInParams"
                @success="onSignInSuccess"
                @error="onSignInError"
              >
                {{ $t("common.binding") }}
              </fb-signin-button>
            </template>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "thirdParty",
  meta: {
    service: false // 客服
  },
  components: {},
  data() {
    return {
      fbSignInParams: {
        scope: "public_profile,email",
        return_scopes: true
      },
      response: {},
      error: {},
      userID: "",
      thirdStatus: {} //第三方状态
    };
  },
  created() {
    this.userBindThirdStatus();
    this.introduceJsFile();
  },
  mounted() {},
  computed: {
    ...mapGetters(["language"])
  },
  methods: {
    unbind(type) {
      let vm = this;
      vm.$dialog
        .confirm({
          message: vm.$t("common.sureRemoveBinding"),
          confirmButtonText: vm.$t("common.yes"),
          cancelButtonText: vm.$t("common.no")
        })
        .then(() => {
          console.log("confirm");
          vm.userBindThird(type);
        })
        .catch(() => {
          console.log("cancel");
        });
    },
    introduceJsFile() {
      // 创建JS引入文件
      var head = document.getElementsByTagName("head")[0];
      var script = document.createElement("script");
      script.async = "async";
      script.defer = "defer";
      script.crossOrigin = "anonymous";
      script.src =
        "https://connect.facebook.net/" +
        (this.language == "en" ? "en_US" : "zh_CN") +
        "/sdk.js#xfbml=1&version=v6.0&appId=605680983386590&autoLogAppEvents=1";
      head.appendChild(script);
      console.log("introduceJsFile", head.appendChild(script));
    },
    onSignInSuccess(response) {
      let vm = this;
      console.log("Success", response); //返回第三方的登录信息 tolen等
      this.response = response;
      /* eslint-disable */
      FB.api("/me", function(response) {
        console.log("/me", response);
        vm.userID = response.id;
        vm.userBindThird(2, response.id);
      });
    },
    onSignInError(error) {
      console.log("Error", error); //返回第三方的登录报错信息
      this.error = error;
    },
    userBindThird(type, id) {
      // 绑定、解绑第三方
      let vm = this;
      let params = {};
      params.type = type;
      params.mark = id;
      let url = ""
      if (id) {
        // 绑定
        url = "/app/user/userBindThird"
      } else {
        // 解绑
        url = "/app/user/userUnbindThird"
      }
      vm.$post(url, params, { loading: true, alert: true }).then(res => {
        console.log(url, res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.userBindThirdStatus();
        }
      });
    },
    userBindThirdStatus() {
      // 第三方绑定状态
      let vm = this;
      vm.$post("/app/user/userBindThirdStatus", {}, { loading: true }).then(res => {
        console.log("userBindThirdStatus", res);
        vm.thirdStatus = res;
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped></style>
